module.exports = __webpack_public_path__ + "images/9e6de303f345b57f731bc7eda6ea467c.svg";